import { render, staticRenderFns } from "./DownloadSection.vue?vue&type=template&id=1a31ae40&scoped=true&"
import script from "./DownloadSection.vue?vue&type=script&lang=js&"
export * from "./DownloadSection.vue?vue&type=script&lang=js&"
import style0 from "./DownloadSection.vue?vue&type=style&index=0&id=1a31ae40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31ae40",
  null
  
)

export default component.exports